export default __webpack_public_path__ + "static/media/BFS-CIRCLE.3ca545b1.png";